export default __webpack_public_path__ + "static/media/photo-agri1.30901bb0.avif";